import { APP_PREFIX, CLIENTS_PREFIX, EDIT_CLIENT, VIEW_CLIENT } from '@app/routes/urls';

/**
 * The two routes to one patient, built from the route constants rather than a
 * literal — the same shape as `visitEditPath` for visits.
 *
 * Which one a surface uses is a decision and not a detail. A patient's NAME in a list
 * goes to the dashboard: the reader clicking it wants to know who this person is, and
 * dropping them into a form with a Save button is an invitation to change something
 * they only meant to look at. Only a control that says "edit" — the row's Edit
 * action, the pencil in the patient picker, the dashboard's own Edit button — goes to
 * the form.
 */
export const clientCardPath = (clientId: number): string =>
  `/${APP_PREFIX}/${CLIENTS_PREFIX}/${VIEW_CLIENT.replace(':id', String(clientId))}`;

export const clientEditPath = (clientId: number): string =>
  `/${APP_PREFIX}/${CLIENTS_PREFIX}/${EDIT_CLIENT.replace(':id', String(clientId))}`;
